
import React from 'react';
import { Email, Item, A} from 'react-html-email';

export default function InlineLink({email, password}) {
    return (
    <Email title='link'>
      <Item>
        <p>Olá você acaba de ser convidado a fazer parte da equipe da construtora Viasul.</p>
      </Item>
      <Item>
        <p>Segue abaixo os seus dados de acesso. Para efetivar o seu cadastro, basta realizar o login e preencher com seus dados pessoais.</p>
      </Item>
      <Item>
        <p>Login Acesso.: {email}</p>
        <p>Senha Acesso.: {password}</p>
      </Item>
      <Item>
        <A href='http://homologacao6.dommusbeta.com.br'>Clicar para acessar o sistema</A>
      </Item>
      <Item>
      <p>A Viasul agradece e te da boas vindas a nossa organização!</p>
      </Item>
    </Email>
  )};